import { render, staticRenderFns } from "./ProductVariantList.vue?vue&type=template&id=e2ec1592&scoped=true&"
import script from "./ProductVariantList.vue?vue&type=script&lang=js&"
export * from "./ProductVariantList.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantList.vue?vue&type=style&index=0&id=e2ec1592&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ec1592",
  null
  
)

export default component.exports